import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const PaymentBTCResponseSchema = z
  .object({
    data: z.object({
      message: z.object({
        status: z.string().or(z.null()),
        data: z.array(z.object({ invoice_id: z.number() })).or(z.null()),
      }),
    }),
  })
  .transform(transformKeysToCamelCase);

export type TPaymentBTCResponse = z.infer<typeof PaymentBTCResponseSchema>;
export type TPaymentBTCData = z.infer<typeof PaymentBTCResponseSchema>['data'];
export type TPaymentBTCDataMessage = z.infer<typeof PaymentBTCResponseSchema>['data']['message'];
export type TPaymentBTCInvoiceId = NonNullable<
  z.infer<typeof PaymentBTCResponseSchema>['data']['message']['data']
>[0];

export const PaymentResponseSchema = z
  .object({
    data: z.object({
      message: z.object({
        payment_link: z.string().or(z.null()),
      }),
    }),
  })
  .transform(transformKeysToCamelCase);

export type TPaymentResponse = z.infer<typeof PaymentResponseSchema>;
export type TPaymentData = z.infer<typeof PaymentResponseSchema>['data'];
export type TPaymentDataMessage = z.infer<typeof PaymentResponseSchema>['data']['message'];

export type TPaymentLink = NonNullable<z.infer<typeof PaymentResponseSchema>['data']['message']>;
